module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prologue")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("“Hello, Bart.” Governor Lila Lockhart spoke softly into the cell phone. With a bodyguard on either side, she had no privacy and it had been that way since the incident.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lila, I’m glad you called. Have there been any more threats?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not since the Rory Stockett shooting, thank goodness. I just called to thank you and your team for all of your help. I couldn’t have gotten through the past two weeks without knowing I had you watching my back.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lila, Rory was hired by someone and that someone still hasn’t been found,” Bart warned. “My men are still on full alert. I expect you to be equally vigilant.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I am, believe me. I hate that all this is happening. I’m beginning to reconsider my options once this gubernatorial term is over.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We’ll find him, Lila. Don’t go making rash decisions based on a crazy man taking potshots at you. You’re not one to run. That’s what I find most attractive about you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lila smiled. “Thanks, Bart. A little flattery always works wonders.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bart chuckled. “My pleasure. Let me know if you need anything else. The men of Corps Security and Investigations are here to help see you through this.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("Lila clicked the off button and leaned back in her seat, the ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("smell of leather relaxing to her senses. It had been a grueling day of meetings, and she couldn’t wait to get home and take a long hot bath.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It seemed a little odd thinking of getting naked in a bathtub with two very large, very strong bodyguards sitting on either side of her. A smile curved her lips. They would be appalled if they could read her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Loud popping sounds erupted around her. The vehicle lurched and skidded sideways, metal screaming against pavement.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lila clutched the armrest. “What’s going on?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bodyguard on her left removed the Sig Sauer pistol from his shoulder holster and leaned forward, bracing his hand on the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The driver clung to the steering wheel, the veins standing out on his forehead as he fought to straighten the vehicle, but the wheels leaped over the shoulder of the road and the limo crashed downward into a ditch and up an embankment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bodyguard with the gun lost his grip on the weapon and grabbed for the armrest on the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With nothing to hold on to, Lila bounced in her seat, flung from side to side like a rag doll.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Barely able to view out the tinted windows, Lila didn’t see the fencepost until the side of the car slammed into it. The bodyguard beside her crashed against the door, his head thumping the window. Bulletproof glass held true, even as the metal frame of the limo bent around the post. The bodyguard went limp.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Lila’s seat belt held her in the middle, but the bodyguard on her other side hit her shoulder, jolting her hard, pain shooting through her neck and back.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("When the world finally came to a jarring halt, the limo horn blared. Lila blinked and dragged in a deep breath, not having realized she’d been holding it since the first pop. The ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("limo listed to the left, pointed back down the embankment at a forty-five degree angle. If not for the seat belt, Lila would have gone through the front windshield.")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Jimmy?” she called out to the driver.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His body slumped over the steering wheel, the source of the horn’s blare.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Jimmy!” Lila fiddled with the belt buckle.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Governor Lockhart, please stay put.” The bodyguard beside her reached out a hand too late to catch her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The buckle opened and Lila fell across the open space between the driver and where she and the bodyguards perched in the rear compartment, slamming headfirst into the back of the driver’s seat.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Stunned, she pushed against the seat so that she could see Jimmy, her driver. Blood dripped down over his arm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Jimmy?” Lila felt for a pulse. For a moment she didn’t feel one and her own heartbeat skittered to a halt. A second later, she could have cried out with joy. The faint thump of blood passing through a vein gave her hope that Jimmy would live.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Help me out of here.” She crawled up the side of the limo, pulling herself along by gripping the upholstery. “We have to get him help.” She stared up at the bodyguard and across to his partner who hung like a crash dummy from the restraints. “What about Tom?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He’s out, but his heartbeat is strong.” The bodyguard above gave her a stern glare. “You have to stay inside the car while I check for trouble outside.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I can’t stand by and do nothing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then find your cell phone and dial 9-1-1.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her heart hammering against her ribs, Lila searched the tilted interior of the limo. It took her three precious minutes to locate her cell phone and even longer to reboot it to get it to work.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her finger hit the speed dial for 9-1-1 and she relayed her location and the condition of the vehicle’s occupants. Then she put the dispatcher on hold and speed dialed Bart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lila?” Bart answered. “What’s wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It happened again.”")])])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b57ce784","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459205987_fm03.vue
// module id = 78
// module chunks = 0